<template>
  <!-- KP-4545: the legacy route opens the same branded lookbook when ready. -->
  <line-sheet-gate
    v-if="publicToken"
    :key="publicToken"
    :public-token="publicToken"
    :query="$route.query"
  >
    <wishlist-products
      v-if="!loading"
      :public-token="publicToken"
    />
  </line-sheet-gate>
</template>

<script>
import useAppConfig from '@/@core/app-config/useAppConfig'
import { onUnmounted } from '@vue/composition-api'
import LineSheetViewTrackingMixin from '@/views/mixins/LineSheetViewTrackingMixin.vue'
import LineSheetGate from '@/views/v2/wishlist/branded/LineSheetGate.vue'
import WishlistProducts from './WishlistProducts.vue'

export default {
  name: 'PublicWishlist',
  components: {
    WishlistProducts,
    LineSheetGate,
  },
  mixins: [LineSheetViewTrackingMixin],
  computed: {
    // From the route, so a new token on the same page opens a fresh gate.
    publicToken() {
      return this.$route.params.publicToken
    },
  },
  mounted() {
    this.reportLineSheetVisit()
  },
  setup() {
    const { isNavMenuHidden } = useAppConfig()

    isNavMenuHidden.value = true

    onUnmounted(() => {
      isNavMenuHidden.value = false
    })
  },
}
</script>
